"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserStatusEnum = void 0;
const UserStatusEnum = exports.UserStatusEnum = {
  NORMAL: 1,
  BLOCKED: 2,
  // Exceeded limit of login attempts
  AUTHENTICATION_DISABLED: 3,
  // Invalid use of token (e.g., had no permission to do a request)
  EXPIRED: 4 // Attempt to login with expired password
};